module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/consigner.27e7fa7c.svg";